/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React from 'react';
import { Auth } from 'aws-amplify';
import { createDocumentAPI, getPresenceToken, manageNotifications } from '../../containers/actions/presence_actions';
import { useDispatch, useSelector } from 'react-redux';
import deviceInfo from '../../libs/BrowserDevices';
import { onAuthStateChanged, getAuth, signInWithCustomToken } from 'firebase/auth';
import { addMyDataToLocalDb, getUserDataByUerId } from '../LocalDB';
import { getDocByDocumentId, updateDocByDocumentId } from './firebaseQuery';
import { toast } from 'react-toastify';
import { PRESENCE_ENUMS } from '../../libs/enums/presenceEnums';
import { getMessaging, getToken } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database'; // Import Realtime Database
import { getFirestore } from 'firebase/firestore';
import { setuserAutoDownloadSetting, setisFireBaseAuth } from '../../redux/PresenceRedux';
import { decryptPresenceToken } from '../../libs/HelperContent';

let firebaseApp; // Variable to hold the Firebase app instance
let firebaseDB;
let firebaseStorage;
let firebaseMessaging;
let firebaseRealtimeDB; // Variable for Realtime Database
const device = deviceInfo();

const configuration = {
	apiKey            : process.env.REACT_APP_PRESENCE_APIKEY,
	authDomain        : process.env.REACT_APP_PRESENCE_AUTH_DOMAIN,
	projectId         : process.env.REACT_APP_PRESENCE_PROJECT_ID,
	storageBucket     : process.env.REACT_APP_PRESENCE_STORAGE_BUCKET,
	messagingSenderId : process.env.REACT_APP_PRESENCE_MSG_SENDER_ID,
	appId             : process.env.REACT_APP_PRESENCE_APP_ID,
	measurementId     : process.env.REACT_APP_PRESENCE_MEASUREMENT_ID,
	vapidKey          : process.env.REACT_APP_PRESENCE_VAPID_KEY
};

const waitForAuthReady = async (auth) =>
{
	return new Promise((resolve) =>
	{
		const unsubscribe = onAuthStateChanged(auth, (user) =>
		{
			unsubscribe(); // Stop listening once the state is resolved
			resolve(user);
		});
	});
};
const useFirebase = () =>
{
	const userData = useSelector((state:any) => state?.mysession?.session);

	const dispatch = useDispatch();

	const updateUserDataInLocalDb = async (selfInfo) =>
	{
	//

		await getUserDataByUerId(selfInfo?.userId).then((response) =>
		{
			if (!response)
			{
				getDocByDocumentId('users', selfInfo?.userId).then((res) =>
				{
					if (res)
					{
						const data = res.data();

						console.log('fdysajksjdduasd', data);
						const autoDownloadSettings = {
							id                         : selfInfo?.userId,
							isAudioAutoDownload        : data?.isAudioAutoDownload,
							isAudioAutoDownloadDTS     : null,
							isAudioAutoDownloadETS     : null,
							isDocumentsAutoDownload    : data?.isDocumentsAutoDownload,
							isDocumentsAutoDownloadDTS : null,
							isDocumentsAutoDownloadETS : null,
							isPhotosAutoDownload       : data?.isPhotosAutoDownload,
							isPhotosAutoDownloadDTS    : null,
							isPhotosAutoDownloadETS    : null,
							isVideoAutoDownload        : data?.isVideoAutoDownload,
							isVideoAutoDownloadDTS     : null,
							isVideoAutoDownloadETS     : null
						};

						dispatch(setuserAutoDownloadSetting(autoDownloadSettings));
						addMyDataToLocalDb(autoDownloadSettings);
					}
				})
					.catch((err) =>
					{
						console.log('error=', err);
					});
			}
			else
			{
				dispatch(setuserAutoDownloadSetting(response));
			}
		})
			.catch((err) =>
			{
				console.log('error=', err);
			});
	};

	const getUserBody = () =>
	{
		return {
			userId             : userData?.userId,
			firstName          : userData?.name,
			email              : userData?.email,
			profileImage       : `${process.env.REACT_APP_S3_BASE_URL}/profile/${userData?.userId}_profile.jpeg`,
			syncDeviceContacts : false,
			profileUpdatedAt   : new Date().valueOf(),
			inlynkUserData    	: {
				empId       : userData?.empId || '',
				designation : userData?.designation || '',
				department  : userData?.department || '',
				phone       : userData?.phone || '',
				companyId   : userData?.companyId || ''
			}
		};
	};

	const handleUserPresence = async (oldToken, newFcmToken) =>
	{
		try
		{
			const userRes = await getDocByDocumentId('users', userData?.userId);

			if (!userRes?.exists())
			{
				await createDocumentAPI({ type: 'user', data: { ...getUserBody(), inLynkTokens: { webTokens: newFcmToken ? [ newFcmToken ] : [] } } });
			}
			else
			{
				const userResponse = userRes?.data();

				// console.log(oldToken, newFcmToken, '-***fcmtoken');

				if (oldToken !== newFcmToken)
				{
					// Update FCM tokens for ALL userIds in companyList
					const companyList = userData?.companyList || [];

					const tokenUpdatePromises = companyList.map(async (company) =>
					{
						try
						{
							// Get user document for this userId
							const companyUserRes = await getDocByDocumentId('users', company?.userId);

							if (companyUserRes?.exists())
							{
								const companyUserData = companyUserRes?.data();
								let existingTokens = [];

								if (companyUserData?.inLynkTokens?.webTokens)
								{
									existingTokens = companyUserData.inLynkTokens.webTokens
										.filter((prevToken) => prevToken !== oldToken && prevToken !== newFcmToken);
								}

								const updates = {
									'inLynkTokens.webTokens' : newFcmToken
										? [ ...existingTokens, newFcmToken ]
										: [ ...existingTokens ]
								};

								await updateDocByDocumentId('users', company?.userId, updates);
							}
						}
						catch (err)
						{
							console.error(`Error updating user tokens for userId ${company?.userId}:`, err);
						}
					});

					await Promise.all(tokenUpdatePromises);
				}

				if (newFcmToken)
				{
					try
					{
						// Map through companyList and call manageNotifications for each userId
						const companyList = userData?.companyList || [];
						const notificationPromises = companyList.map((company) =>
							manageNotifications({ userId: company?.userId, token: newFcmToken, subscribe: true, scenario: 'login' })
								.catch((err) => console.error(`Error managing notifications for userId ${company?.userId}:`, err))
						);

						await Promise.all(notificationPromises);
					}
					catch (err)
					{
						console.error('Error managing notifications:', err);
					}
				}
				if (Object.keys(userRes?.data()?.inlynkUserData || {}).length === 0)
				{
					// temporarily adding inlynk userdata for development purpose only
					// reed to remove later as this will already be added in first
					// if statements for new accounts

					console.log('updating inlynkUserData in users collection******');

					const inlynkUserData = {
						empId       : userData?.empId || '',
						designation : userData?.designation || '',
						department  : userData?.department || '',
						phone       : userData?.phone || '',
						companyId   : userData?.companyId || ''
					};

					try
					{
						await updateDocByDocumentId('users', userData?.userId, { inlynkUserData });
					}
					catch (err)
					{
						console.error('Error updating inlynkUserData:', err);
					}
				}
			}
		}
		catch (err:any)
		{
			toast.error(err.message);
		}
	};

	const fetchToken = async (retryCount = 2) =>
	{
		const token = await generateToken();

		if (token)
		{
			return token;
		}
		if (retryCount > 0 && Notification.permission === 'granted')
		{
			await new Promise((resolve) => setTimeout(resolve, 1000));

			return fetchToken(retryCount - 1);
		}

		return null;
	};

	// Helper function to update local user data and tokens
	const handleAuthenticatedUser = async () =>
	{
		await updateUserDataInLocalDb(userData);

		const prevToken = sessionStorage.getItem('fcmToken');
		let fcmToken:any = null;

		if (!([ 'mobile', 'tablet' ].includes(device?.platform)) && 'Notification' in window && 'serviceWorker' in navigator)
		{
			fcmToken = await fetchToken(); // Use the fetchToken function with retries
		}

		// Check if the new token differs from the previous one, and update sessionStorage if necessary
		if (fcmToken !== prevToken)
		{
			sessionStorage.setItem('fcmToken', fcmToken);
		// removing the previous token while updating to firebase in "handleUserPresence" function
		}
		// Create or update the webTokens in Firebase
		await handleUserPresence(prevToken, fcmToken);

		// return fcmToken;
		dispatch(setisFireBaseAuth(PRESENCE_ENUMS.connected));

		return { isFirebaseAuthDone: true };
	};

	const registerServiceWorker = async () =>
	{
		try
		{
			if ('serviceWorker' in navigator)
			{
				const getRegisterations = await navigator?.serviceWorker?.getRegistrations();

				const desiredScope = `${window?.location?.origin}/`;

				if (getRegisterations?.length > 0)
				{
					const existingRegistration = getRegisterations?.[0];
					const existingScope = existingRegistration?.scope;

					if (existingScope === desiredScope)
					{
						return existingRegistration;
					}

					// If not, unregister the previous SW and register a new one
					await existingRegistration?.unregister();
				}
				try
				{
					const newRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

					return newRegistration;
				}
				catch (error)
				{
					return error;
				}
			}
			else
			{
				console.log('service worker failed');

				return 'service worker not supported';
			}
		}
		catch (err)
		{
			console.log(err, '--------err');

			return err;
		}
	};

	const requestNotificationPermission = async () =>
	{
		if (!('Notification' in window))
		{
			console.warn('Notifications not supported.');

			return false;
		}

		try
		{
			const permission = Notification.permission;

			if (permission)
			{
				const result = await Promise.race([ Notification.requestPermission(), new Promise((_resolve, reject) =>
					setTimeout(() => reject(new Error('Permission request timed out')), 5000)
				) ]);

				return result === 'granted';
			}

			return permission === 'granted';
		}
		catch (err)
		{
			console.error('Error requesting permission:', err);

			return false;
		}
	};

	const getFCMToken = async () =>
	{
		try
		{
			// Assuming firebaseMessaging is initialized and ready
			const token = await getToken(firebaseMessaging, { vapidKey: JSON.parse(process.env.REACT_APP_PRESENCE || '""')?.vapidKey });

			return token;
		}
		catch (err)
		{
			console.error('Error getting token:', err);

			return null;
		}
	};

	async function generateToken()
	{
		try
		{
			// Ensure service worker registration
			const register = await registerServiceWorker();

			// Wait until the service worker is ready
			const navigatorRes = await navigator.serviceWorker.ready;

			if (navigatorRes?.active && userData?.userId)
			{
				// Send all userIds from companyList for multi-company notification support
				const allUserIds = userData?.companyList?.map((company: any) => company?.userId)?.filter(Boolean) || [];
				// Send all companyIds from companyList
				const allCompanyIds = userData?.companyList?.map((company: any) => company?.companyId)?.filter(Boolean) || [];

				navigatorRes.active.postMessage({
					type            : 'SET_USER_DATA',
					userIds         : allUserIds,
					companyIds      : allCompanyIds,
					activeCompanyId : userData.companyId
				});
				console.log('Sent all userIds and companyIds to service worker:', { userIds: allUserIds, companyIds: allCompanyIds, activeCompanyId: userData.companyId });
			}

			// Request notification permissions if not granted yet
			const permissionGranted = await requestNotificationPermission();

			if (!permissionGranted)
			{
				return null;
			}

			const token = await getFCMToken();

			return token;
		}
		catch (error)
		{
			console.error('Error during token generation:', error);

			return null;
		}
	}

	const firebaseInitialisationOnLogin = async (body:any = null) =>
	{
		if (!firebaseApp)
		{
			firebaseApp = initializeApp(configuration);
			firebaseDB = getFirestore(firebaseApp);
			firebaseStorage = getStorage(firebaseApp);
			if (!([ 'mobile', 'tablet' ].includes(device?.platform)) && 'Notification' in window && 'serviceWorker' in navigator)
			{
				firebaseMessaging = getMessaging(firebaseApp);
			}
			else
			{
				firebaseMessaging = null;
			}
			firebaseRealtimeDB = getDatabase(firebaseApp); // Initialize Realtime Database
		}

		if (body)
		{
			try
			{
				dispatch(setisFireBaseAuth(PRESENCE_ENUMS.connecting));
				const decryptToken:any = await decryptPresenceToken(body?.token);

				if (decryptToken)
				{
					const auth = getAuth();
					const user = await waitForAuthReady(auth);

					if (user)
					{
						return await handleAuthenticatedUser();
					}
					else
					{
						console.log('User is not signed in, attempting custom token authentication...');

						const session:any = await Auth.currentSession();

						if (session?.accessToken?.payload?.token_use === 'access')
						{
							const userCredential = await signInWithCustomToken(auth, decryptToken);

							console.log('Signed in with custom token:', userCredential.user);

							return await handleAuthenticatedUser();
						}
						else
						{
							console.log('No valid session found. Redirecting to login...');

							return { isFirebaseAuthDone: false };
						}
					}
				}
			}
			catch (err)
			{
				dispatch(setisFireBaseAuth(''));
				console.error('Authentication error:', err);

				return { isFirebaseAuthDone: false };
			}
		}
	};

	const handleFirebaseInitialisation = async (body) =>
	{
		const isLoggedIn = await Auth.currentUserInfo();

		if (Boolean(isLoggedIn) && Object.keys(isLoggedIn)?.length > 0)
		{
			// Firebase will be initialized and the token will be
			// fetched and updated in session storage and the Firebase database
			await firebaseInitialisationOnLogin(body);
		}
	};

	const getUserTokenPresence = async () =>
	{
		const tokenBody = { uid: userData?.userId };

		let presenceToken = { token: null };

		try
		{
			presenceToken = await getPresenceToken(tokenBody);
		}
		catch (err)
		{
			console.error('Error getting presence token:', err);
		}

		if (presenceToken && presenceToken?.token)
		{
			const decryptToken = await decryptPresenceToken(presenceToken?.token);

			// due to race condition sometimes below userData(old) is overwriting the latest userData through redux
			// setting presence token is not required not being used anywhere in application
			// const newObj = { ...userData, presenceUserToken: decryptToken };

			// dispatch(getUserSession(newObj));

			const body = {
				token  : presenceToken?.token,
				userId : userData?.userId
			};

			await handleFirebaseInitialisation(body);

			return '';
		}
	};

	return { getUserTokenPresence };
};

export default useFirebase;
export { firebaseDB, firebaseMessaging, firebaseRealtimeDB, firebaseStorage };